import HttpClient from "../../utils/http";
import { Merchant, Voucher, MerchantListResponse, VoucherListResponse } from "../../views/merchant/model/merchant_model";
import { getMerchants, getVouchers } from "../constants/api_endpoints";

// API Request/Response interfaces
export interface CreateVoucherRequest {
  amount: number;
  number_of_vouchers: number;
}

export interface CreateMerchantRequest {
  name: string;
  status: string;
  pincode: number;
  location: string;
  mobile: string;
}

export interface AssignVouchersRequest {
  merchant_id: string;
  number_of_vouchers: number;
}

export interface AssignVouchersResponse {
  assigned: number;
  vouchers: Voucher[];
}


export function getMerchantList({
  page,
  size,
  keyword,
  sortBy,
  sortOrder,
  fromDate,
  toDate,
  orgId,
}: {
  page: number;
  size: number;
  keyword?: string;
  sortBy?: string;
  sortOrder?: string;
  fromDate?: string;
  toDate?: string;
  orgId?: number | null;
}): Promise<{ data: { data: any } }> {
  let url = `${getMerchants}?size=${size}&page=${page}`;
  if (keyword) url += `&keyword=${encodeURIComponent(keyword)}`;
  if (sortBy) url += `&sortBy=${sortBy}`;
  if (sortOrder) url += `&sortOrder=${sortOrder}`;
  if (fromDate) url += `&dateFrom=${fromDate}`;
  if (toDate) url += `&dateTo=${toDate}`;
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url);
}

export function getMerchantsByPincode(pincode: string | number): Promise<any> {
  const url = `${getMerchants}/pincode/${encodeURIComponent(String(pincode))}`;
  return HttpClient.get(url);
}

export function getVoucherList({
  page,
  size,
  keyword,
  sortBy,
  sortOrder,
  dateFrom,
  dateTo,
  orgId,
}: {
  page: number;
  size: number;
  keyword?: string;
  sortBy?: string;
  sortOrder?: string;
  dateFrom?: string;
  dateTo?: string;
  orgId?: number | null;
}): Promise<{ data: { data: VoucherListResponse } }> {
  let url = `${getVouchers}?size=${size}&page=${page}`;
  if (keyword) url += `&keyword=${encodeURIComponent(keyword)}`;
  if (sortBy) url += `&sortBy=${sortBy}`;
  if (sortOrder) url += `&sortOrder=${sortOrder}`;
  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url);
}
